import React, { useState } from 'react';

import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';

import {sendAuthenticatedAsyncRequest} from 'services/AsyncRequestService';
import { showNotification } from 'services/NotificationService';

const CloseWorkflowForSwitches = () => {
  const [asyncInProgress, setAsyncInProgress] = useState(false);

  const closeWorkflowForSwitches = () => {
    setAsyncInProgress(true);
    sendAuthenticatedAsyncRequest(
      `/wf/close-switches-on-no-response`,
      "GET", 
      null,
      (r) => {
        setAsyncInProgress(false);
        let switches = r.data;
        showNotification({
          title: 'Action successful!',
          message: switches > 0 
            ? `Workflow successfully closed for ${switches} switch(es)`
            : 'No switches avaialable to be closed in database',
          position: 'tc',
          type: "info"
        });
      },
      (r) => setAsyncInProgress(false)
    );
  }

  return (
    <Card style={{textAlign:'center'}}>
      <Card.Body>
        <Card.Text>
          Close old switches?
        </Card.Text>
        <Button variant='danger' disabled={asyncInProgress} onClick={closeWorkflowForSwitches}>
          {!asyncInProgress ? 'Close Switches' : 'Closing Switches ...'}
        </Button>
      </Card.Body>
    </Card>
  );
}

export default CloseWorkflowForSwitches;
